import React, { useRef } from 'react';
import { map, isEmpty } from 'lodash';
import classNames from 'classnames';

import { SubMenu } from 'components/subMenu/subMenu';
import { Divider } from 'components/divider/divider';
import { MenuItemCard } from 'components/menuItemCard/menuItemCard';
import { MenuScrollable } from 'components/menuScrollable/menuScrollable';
import { Dropdown } from 'components/dropDown/dropDown';
import { avatarOptions } from 'components/avatar/avatar';

// import { avatarSize } from 'redux/modules/ui';

import styles from './projectsDropdown.module.scss';
import { useProjectaddCandidateMutation } from '../../redux/modules/projects';
import { projectCandidatesCacheKey } from '../../utils/useProjectCandidates';
import toast from 'react-hot-toast';

// import { COLUMNS } from 'redux/modules/cards';

export const ProjectsDropdown = ({
  projectsData,
  onClick,
  children,
  disabled,
  zIndex,
  toRight,
  buttonComponent,
  applicant,
  inline,
  showClientColumn = false,
  clientProjectStageFlow = false,
  colors,
}) => {
  const avatarSize = 40;

  return (
    <>
      {disabled && children}
      {!disabled && (
        <Dropdown
          className={classNames(styles.projectsDropdownWrapper, { [styles.inline]: true })}
          trigger={children}
          zIndex={zIndex}
          disabled={disabled}
          toRight={toRight}
          buttonComponent={buttonComponent}
        >
          {projectsData?.length > 0 && <Divider size="large">Select Client Name</Divider>}

          {projectsData?.length < 0 && (
            <>
              <Divider size="large">No projects</Divider>
              <div className={styles.noProjectWarning}>
                Looks like you haven&#039;t setup any projects
              </div>
            </>
          )}

          <MenuScrollable>
            {map(projectsData, (project, index) => {
              // Match color logic to ClientDropdownWithProjects
              let avatarColor;
              if (project.colour && project.colour.hex) {
                avatarColor = project.colour.hex;
              } else if (colors && colors.length > 0 && project.colour_id) {
                const found = colors.find(col => Number(col.id) === Number(project.colour_id));
                avatarColor = found && found.hex;
              } else {
                avatarColor = undefined;
              }
              return (
                <div className={classNames('project', styles.applicantProjects)} key={index}>
                  <SubMenu
                    className={classNames(styles.projectsPipelineWrapper)}
                    zIndex={13}
                    menuItem={
                      <MenuItemCard
                        key={`project-${project.id}`}
                        avatar={{ ...avatarOptions(project, 'project'), size: avatarSize.medium, color: avatarColor, className: 'avatarDropdown' }}
                        name={project.title}
                        subhead={project.client && project.client.title}
                        color={avatarColor}
                      />
                    }
                  >
                    <Divider size="large">Select project stage</Divider>
                    <div className={classNames('project', styles.applicantProjects)}>
                      <MenuItemCard
                        size={44}
                        key={`project-${project.id}`}
                        avatar={{ ...avatarOptions(project, 'project'), size: avatarSize.medium, color: avatarColor }}
                        name={project.title}
                        subhead={project.client && project.client.title}
                        color={avatarColor}
                      />
                    </div>
                    <ProjectStageChoices project={project} applicant={applicant} />
                  </SubMenu>
                </div>
              );
            })}
          </MenuScrollable>
        </Dropdown>
      )}
    </>
  );
};

const ProjectStageChoices = ({ project, applicant }) => {
  const pending = useRef(false);
  const [addApplicant, mutation] = useProjectaddCandidateMutation({
    fixedCacheKey: projectCandidatesCacheKey(project.id),
  });
  const disabled = mutation.isLoading;

  const addApplicantToPipeline = async (stageId) => {
    if (disabled || pending.current) return;
    pending.current = true;
    try {
      await addApplicant({ projectId: project.id, userId: applicant.id, stageId }).unwrap();
      toast.success('Applicant Added To Pipeline!');
    } catch (error) {
      toast.error('Failed To Add Applicant To Pipeline!');
    } finally {
      pending.current = false;
    }
  };

  return map(
    project?.pipeline?.pipeline_stages,
    (stage) =>
      !isEmpty(stage) && (
        <div className="px-1" key={stage.id}>
          <div className={classNames('project', styles.applicantProjects)}>
            <MenuItemCard
              size={44}
              name={stage.title}
              onClick={() => addApplicantToPipeline(stage.id)}
            />
          </div>
        </div>
      ),
  );
};
